<template>
  <div class="main-container">

    <router-view></router-view>
    <!-- Navbar section -->
    <!-- Navbar section -->
    <!-- breadcrumb strat -->
    <Breadcrumb>
      <template slot="breadcrumb">

        <div class="breadcrumb_box text-center">
          <h3 class="breadcrumb-title">Flame Graph</h3>
          <!-- breadcrumb-list start -->
          <ul class="breadcrumb-list">

            <li class="breadcrumb-item active">gh</li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">{{ $route.params.org }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">{{ $route.params.repo }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">{{ $route.params.commit }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">benchmark = {{ $route.params.bench }}</router-link>
            </li>
            <li class="breadcrumb-item active">CPU</li>

          </ul>

          <!-- breadcrumb-list end -->

        </div>

      </template>

    </Breadcrumb>
    <!-- breadcrumb end -->

    <b-card-header header-tag="nav">
      <b-nav card-header tabs>
        <b-nav-item :to="{name:'top-cpu-functions'}" :active='$route.name =="top-cpu-functions" || $route.name =="top-cpu"'>CPU by Function</b-nav-item>
        <b-nav-item :to="{name:'top-cpu-lines'}" :active='$route.name =="top-cpu-lines"'>CPU by LOC</b-nav-item>
        <b-nav-item :to="{name:'cpu-flamegraph'}" :active='$route.name =="cpu-flamegraph"'>FlameGraph</b-nav-item>
      </b-nav>
    </b-card-header>


    <!-- blog item wrapper start -->
    <div class="blog-pages-wrapper border-bottom">

      <div class="container">
        <v-container>
          <form class="form-inline" id="form" :action="search">
            <input type="text" class="ht-btn ht-btn-md btn-text-theme btn--white" placeholder="Enter search keyword..."  id="term">
            <button v-on:click="search" class="ht-btn ht-btn-md ht-btn-full">Search</button>
            <button v-on:click="resetZoom" class="ht-btn ht-btn-md ht-btn-md">Reset Zoom</button>
            <button v-on:click="clear" class="ht-btn ht-btn-md ht-btn-full">Clear</button>
          </form>
        <v-row>
          <v-col id="flamegraphdetail" class="flamegraph-details " />
        </v-row>
        <v-row>
          <v-col id="flamegraph" class="flamegraph-content"/>
        </v-row>
      </v-container>
        </div>
        </div>

    <!-- footer section -->
    <FooterMain />

  </div>
</template>

<script>

import FooterMain from "../components/FooterMain";
import Breadcrumb from "../components/Breadcrumb";
import * as d3 from "d3";
import * as d3flame from "d3-flame-graph";
import axios from "axios";
import { format } from 'd3-format';

export default {
  name: "FlameGraphs",
  components: {
    FooterMain,
    Breadcrumb,
},
  data() {
    return {
      flamedata: {}
    };
  },
  //this one will populate new data set when user changes current page.
  mounted() {
    this.readDataFromAPI();
    //this.generateFlameGraph();
  },
  methods: {

    //Reading data from API method.
    readDataFromAPI() {
      let parameters = this.$route.params;
      let end = process.env.VUE_APP_API_CODEPERF_IO_URL;
      let u = process.env.VUE_APP_API_CODEPERF_IO_USERNAME;
      let p = process.env.VUE_APP_API_CODEPERF_IO_PASSWORD;
      axios
          .get(
              end + "/v1/gh/" +
              parameters.org + "/" + parameters.repo + "/commit/" + parameters.commit
              + "/bench/" + parameters.bench
              + "/cpu/flamegraph",
              {
                auth: {
                  username: u,
                  password: p
                }
              })
          .then((response) => {
            this.flamedata = response.data;
            this.generateFlameGraph();
          })
          .catch(error => {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              // console.log(error.response.data);
              // console.log(error.response.status);
              // console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              //console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              //console.log('Error', error.message);
            }
          });
    },
    generateFlameGraph() {
      var width = document.getElementById('flamegraph').clientWidth;

      this.flameGraph = d3flame.flamegraph()
          .width(width)
          .cellHeight(18)
          .minFrameSize(1)
          .transitionDuration(750)
          .transitionEase(d3.easeCubic)
          .inverted(true)
          .sort(true)
          .title('')
          .tooltip(false);

      d3.select("#flamegraph")
          .datum(this.flamedata)
          .call(this.flameGraph);

      let getName = function (d) {
        return d.data.f || d.data.n || d.data.name
      }

      let getValue = function (d) {
        if ('v' in d) {
          return d.v
        } else {
          return d.value
        }
      }

      const details = document.getElementById("flamegraphdetail");
      let labelHandler = function (d) {
        return getName(d) + ' (' + format('.3f')(100 * (d.x1 - d.x0), 3) + '%, ' + getValue(d) + ' samples)'
      }
      this.flameGraph.label(labelHandler)

      this.flameGraph.setDetailsElement(details);
      var oldColorMapper = this.flameGraph.color();
      function colorMapper(d) {
        // Hack to force default color mapper to use 'warm' color scheme by not passing libtype
        const { data, highlight } = d;
        return oldColorMapper({ data: { n: data.n }, highlight });
      }

      (function(flameGraph) {


        flameGraph.color(colorMapper);
      }(this.flameGraph));

      document.getElementById("form").addEventListener("submit", function(event){
      event.preventDefault();
      this.search();
      });
    },
    search(){
      const term = document.getElementById("term").value;
      if (this.flameGraph){
        this.flameGraph.search(term);
      }
    },
    clear() {
      document.getElementById('term').value = '';
      if (this.flameGraph){
        this.flameGraph.clear();
      }
    },
    resetZoom() {
      if (this.flameGraph){
        this.flameGraph.resetZoom();
      }
    }
  }
};
</script>

<style type="text/css">
.flamegraph-content {
  width: 90%;
  min-width: 80%;
}
.flamegraph-details {
  height: 1.2em;
  width: 90%;
  min-width: 90%;
  padding: 15px 0 35px;
}
</style>
